import { Auth0Client } from '@auth0/auth0-spa-js'
import auth0 from 'auth0-js'

import { chromeSendMessage } from '../chrome'
import { trackEvent, trackIdentify, trackIdentifyAnonymous, useTranslationInternal } from '../helpers'
import { getRedirectTo, removeRedirectTo } from '../localStorageHelpers'

const prefix = '@@auth0spajs@@'
const audience = 'https://dev-6bo5ewfl.eu.auth0.com/api/v2/'
const scope = 'openid profile email offline_access'

export const saveAndSendAuthDataToExtension = (accessToken, refreshToken, expiresAt, idToken) => {
  chromeSendMessage({
    type: 'authorization',
    accessToken,
    refreshToken,
    expiresAt,
    idToken
  })

  localStorage.setItem('underline', JSON.stringify({
    accessToken,
    refreshToken,
    expiresAt,
    idToken,
  }))
}

export const getAndRedirectUser = (api, accessToken, idToken, navigateFunc, authType) => {
  api.setHeader('Authorization', `Bearer ${accessToken}`)
  api.setHeader('id_token', idToken)
  api.setHeader('app-type', 'chrome-extension')
  api.getUser().then(response => {
    trackIdentifyAnonymous({ auth_type: authType })

    trackIdentify(response.data.id, response.data.email)

    console.log('response.data')
    console.log(response.data)

    chromeSendMessage({
      type: 'identify',
      id: response.data.id
    })

    const hasFinishedRequiredOnboardingSteps = response.data.native_language && response.data.learning_languages.length > 0
    const extensionSettings = response.data.extension_settings
    const hasMobileApp = response.data.apps?.mobile

    chromeSendMessage({
      place: 'login_without_onboarding',
      type: 'useContextMenu',
      language: !!response.data.extension_settings?.use_context_menu
    })

    if (hasFinishedRequiredOnboardingSteps) {
      chromeSendMessage({
        place: 'login_without_onboarding',
        type: 'languagesToLearn',
        languagesToLearn: response.data.learning_languages,
      })

      chromeSendMessage({
        place: 'login_without_onboarding',
        type: 'nativeLanguage',
        language: response.data.native_language,
      })
    }
    const redirectTo = getRedirectTo()
    if (redirectTo && hasFinishedRequiredOnboardingSteps) {
      removeRedirectTo()
      navigateFunc(redirectTo)
    } else {
      navigateFunc('/app/intro', {
        state: {
          hasFinishedRequiredOnboardingSteps: hasFinishedRequiredOnboardingSteps,
          extensionSettings: extensionSettings,
          hasMobileApp: hasMobileApp
        }
      })
    }
  })
}

export const localStorageKey = `${prefix}::${process.env.AUTH0_CLIENT_ID}::${audience}::${scope}`

export const useAuth0 = () => {
  const initializedWebAuth0 = new auth0.WebAuth({
    domain: process.env.AUTH0_DOMAIN,
    clientID: process.env.AUTH0_CLIENT_ID,
    responseType: 'token id_token',
    scope: scope,
    audience
  })
  const initializedAuth0 = new Auth0Client({
    domain: process.env.AUTH0_DOMAIN,
    client_id: process.env.AUTH0_CLIENT_ID,
    useRefreshTokens: true,
    cacheLocation: 'localstorage',
    scope: scope,
    audience
  })

  return { initializedAuth0, initializedWebAuth0, auth0LocalStorageKey: localStorageKey }
}

export const refreshAccessToken = () => {
  // Dorobić odswiezanie takza dla hasła?
  const initializedAuth0 = new Auth0Client({
    domain: process.env.AUTH0_DOMAIN,
    client_id: process.env.AUTH0_CLIENT_ID,
    useRefreshTokens: true,
    cacheLocation: 'localstorage',
    scope: scope,
    audience
  })

  return initializedAuth0.getTokenSilently({
    timeoutInSeconds: 10
  })

}

export const getAuth0Errors = (response) => {
  if (response.code === 'invalid_password') {
    return 'Czy twoje hasło zawiera min. 6 znaków?'
  } else if (response.code && response.code.includes('error in email')) {
    return 'Czy to na pewno jest prawidłowy adres email?'
  } else if (response.description && response.description.includes('Wrong email or password')) {
    return 'auth.wrongData'
  } else if (response.code === 'too_many_attempts') {
    return 'auth.toManyAttemps'
  } else {
    return 'auth.emailUsed'
  }
}
